import { useCallback, useEffect, useMemo } from 'react';
import { createHref } from 'retil-history';
import { useResolveRoute } from './useResolveRoute';
import { useNavigate } from './useNavigate';
import { usePrefetch } from './usePrefetch';
export var useLink = function (to, options) {
    var disabled = options.disabled, prefetchOn = options.prefetchOn, replace = options.replace, state = options.state, onClick = options.onClick, onMouseEnter = options.onMouseEnter;
    var navigate = useNavigate();
    var prefetch = usePrefetch();
    var action = useResolveRoute(to, state);
    var doPrefetch = useMemo(function () {
        var hasPrefetched = false;
        return function () {
            if (!hasPrefetched && action && prefetch) {
                hasPrefetched = true;
                prefetch(action);
            }
        };
    }, [action, prefetch]);
    // Prefetch on mount if required, or if `prefetch` becomes `true`.
    useEffect(function () {
        if (prefetchOn === 'mount') {
            doPrefetch();
        }
    }, [prefetchOn, doPrefetch]);
    var handleMouseEnter = useCallback(function (event) {
        if (prefetchOn === 'hover') {
            if (onMouseEnter) {
                onMouseEnter(event);
            }
            if (disabled) {
                event.preventDefault();
                return;
            }
            if (!event.defaultPrevented) {
                doPrefetch();
            }
        }
    }, [disabled, doPrefetch, onMouseEnter, prefetchOn]);
    var handleClick = useCallback(function (event) {
        // Let the browser handle the event directly if:
        // - The user used the middle/right mouse button
        // - The user was holding a modifier key
        // - A `target` property is set (which may cause the browser to open the
        //   link in another tab)
        if (event.button === 0 &&
            !(event.altKey || event.ctrlKey || event.metaKey || event.shiftKey)) {
            if (disabled) {
                event.preventDefault();
                return;
            }
            if (onClick) {
                onClick(event);
            }
            if (!event.defaultPrevented && action) {
                event.preventDefault();
                navigate(action, { replace: replace });
            }
        }
    }, [disabled, action, navigate, onClick, replace]);
    return {
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        href: action ? createHref(action) : to,
    };
};
